import React from "react";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailCompose from "../pages/Email/email-compose";

import Emailtemplatealert from "../pages/EmailTemplate/email-template-alert";
import Emailtemplatebasic from "../pages/EmailTemplate/email-template-basic";
import Emailtemplatebilling from "../pages/EmailTemplate/email-template-billing";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";
import MapsVector from "../pages/Maps/MapsVector";
import MapsLeaflet from "../pages/Maps/MapsLeaflet";

//Icons
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import TypiconsIcon from "../pages/Icons/IconTypicons";
import IconIon from "../pages/Icons/IconIon";
import ThemifyIcon from "../pages/Icons/IconThemify";
import IconFontawesome from "../pages/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";

// Forms
import FormElements from "../pages/Forms/FormElements";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiUtilities from "pages/Ui/UiUtilities";
import UiOffcanvas from "pages/Ui/UiOffcanvas";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesInvoice from "../pages/Utility/PagesInvoice";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import PagesGallery from "../pages/Utility/PagesGallery";
import PagesDirectory from "../pages/Utility/PagesDirectory";
import PagesProfile from "pages/Utility/pages-profile";
import AllLeads from "pages/Leads/AllLeads/AllLeads";
import AddLeads from "pages/Leads/AddLeads/AddLeads";
import SingleLeads from "pages/Leads/SingleLeads/SingleLeads";
import AllClients from "pages/Clients/AllClients/AllClients";
import ProjectDetails from "pages/Project/ProjectDetails";
import AllProjects from "pages/Project/AllProjects";
import CreateUser from "pages/users/CreateUser";
import AllUsers from "pages/users/AllUsers";
import CreateClient from "pages/Clients/CreateClient";
import AddEarning from "pages/AddEarning/AddEarning";
import AllEarnings from "pages/AllEarnings/AllEarnings";
import AddCosting from "pages/AddCosting/AddCosting";
import AllCostings from "pages/AllCostings/AllCostings";
import AllAnalytics from "pages/Analytics/AllAnalytics";
import Transactions from "pages/Transactions/Transactions";
import AddWorkLog from "pages/WorkLog/AddWorkLog";
import AllWorkLogs from "pages/WorkLog/AllWorkLogs";
import EditWorkLog from "pages/WorkLog/EditWorkLog";
import AllLeadsSummary from "pages/LeadsSummary/AllLeadsSummary";
import AllFixedCosts from "pages/FixedCosts/AllFixedCosts";
import AdminDashboard from "pages/Dashboard/AdminDashboard";
import AllOrders from "pages/Orders/AllOrders";
import AllMedicinesDiscount from "pages/Discount/AllMedicinesDiscount";
import AllPromoCodes from "components/PromoCode/AllPromoCodes";
import AllProducts from "components/Products/AllProducts";
import QwikMedicDashboard from "pages/Dashboard/QwikMedicDashboard";
import OrderDetailsPage from "pages/Orders/OrderDetailsPage";
import AllMedicines from "pages/Medicines/AllMedicines";
import AllProductsDiscount from "pages/Discount/AllProductsDiscount";
import AllMedicineRequests from "pages/MedicineRequest/AllMedicineRequests";
import AllHelpSupport from "pages/HelpSupport/AllHelpSupport";
import AllQwikBistroOrders from "pages/Orders/AllQwikBistroOrders";
import AllCustomers from "pages/Customers/AllCustomers";
import AllCoupons from "pages/Coupons/AllCoupons";
import AllMenuItems from "pages/Product/AllMenuItems";
import CreateMenuItem from "pages/Product/CreateMenuItem";
import AllExpenses from "pages/Expenses/AllExpenses";
import AllIngredients from "../pages/Ingredient/AllIngredients";
import Analytics from "pages/Analytics/Analytics";
import AllRecipes from "pages/Recipes/AllRecipes";
import CreateRecipePage from "pages/Recipes/CreateRecipePage";
import CreateQwikBistroOrderPage from "pages/Orders/CreateQwikBistroOrderPage";
import UpdateQwikBistroOrder from "pages/Orders/UpdateQwikBistroOrder";
import CustomerDetailsPage from "pages/Customers/CustomerDetailsPage";
import CreateCustomerPage from "pages/Customers/CreateCustomerPage";
import CreatePaymentPage from "pages/Payments/CreatePaymentPage";
import CreateCoupon from "pages/Coupons/CreateCoupon";
import CreateExpense from "pages/Expenses/CreateExpense";
import AllJobs from "pages/Jobs/AllJobs";
import CreateJob from "pages/Jobs/CreateJob";
import AllJobApplications from "pages/Jobs/AllJobApplications";
import AllQwikMedicUser from "pages/users/AllQwikMedicUser";
import CreateQwikMedicUser from "pages/users/CreateQwikMedicUser";
import ProjectInvoice from "pages/Project/ProjectInvoice";
import MoneyReceipt from "pages/Project/MoneyReceipt";
import AllInvoices from "pages/Invoice/AllInvoices";
import ViewInvoice from "pages/Invoice/ViewInvoice";
import AllMoneyReceipts from "pages/MoneyReceipts/AllMoneyReceipts";
import ViewMoneyReceipt from "pages/MoneyReceipts/ViewMoneyReceipt";

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // //calendar
  { path: "/calendar", component: <Calendar /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-compose", component: <EmailCompose /> },

  // Email Template
  { path: "/email-template-alert", component: <Emailtemplatealert /> },
  { path: "/email-template-basic", component: <Emailtemplatebasic /> },
  { path: "/email-template-billing", component: <Emailtemplatebilling /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },

  // Icons
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icons-ion", component: <IconIon /> },
  { path: "/icons-themify", component: <ThemifyIcon /> },
  { path: "/icons-typicons", component: <TypiconsIcon /> },

  // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },

  // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },
  { path: "/maps-leaflet", component: <MapsLeaflet /> },

  // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-mask", component: <FormMask /> },
  { path: "/form-repeater", component: <FormRepeater /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-validation", component: <FormValidations /> },

  // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rating", component: <UiRating /> },
  { path: "/ui-utilities", component: <UiUtilities /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-invoice", component: <PagesInvoice /> },
  { path: "/pages-directory", component: <PagesDirectory /> },
  { path: "/pages-faqs", component: <PagesFaqs /> },
  { path: "/pages-pricing", component: <PagesPricing /> },
  { path: "/pages-gallery", component: <PagesGallery /> },
  { path: "/pages-profile", component: <PagesProfile /> },

  //leads
  { path: "/all-leads", component: <AllLeads /> },
  { path: "/add-lead", component: <AddLeads /> },
  { path: "/leads/:id", component: <SingleLeads /> },
  // this route should be at the end of all other routes
  { path: "/", component: <Dashboard /> },

  //client
  { path: "/all-clients", component: <AllClients /> },


  { path: "/projects/:id", component: <ProjectDetails /> },
  // { path: "/clients/:id", component: <ClientDetails /> },


  { path: "/all-projects", component: <AllProjects /> },

  { path: "/all-projects/invoice/:projectId", component: <ProjectInvoice /> },
  { path: "/all-invoices", component: <AllInvoices /> },
  { path: "/invoice/:id", component: <ViewInvoice /> },


  { path: "/all-projects/money-receipt/:projectId", component: <MoneyReceipt /> },
  { path: "/all-money-receipt", component: <AllMoneyReceipts /> },
  { path: "/money-receipt/:id", component: <ViewMoneyReceipt /> },

  { path: "/create-user", component: <CreateUser /> },
  { path: "/all-users", component: <AllUsers /> },


  { path: "/all-jobs", component: <AllJobs /> },
  { path: "/create-job", component: <CreateJob /> },
  { path: "/all-job-applications", component: <AllJobApplications /> },



  // qwik medic 
  { path: "/all-qwik-medic-users", component: <AllQwikMedicUser /> },
  { path: "/create-qwik-medic-user", component: <CreateQwikMedicUser /> },
  { path: "/all-orders", component: <AllOrders /> },
  { path: "/order/:id", component: <OrderDetailsPage /> },
  { path: "/medicine-discount", component: <AllMedicinesDiscount /> },
  { path: "/product-discount", component: <AllProductsDiscount /> },
  { path: "/promo-codes", component: <AllPromoCodes /> },
  { path: "/all-products", component: <AllProducts /> },
  { path: "/medicines", component: <AllMedicines /> },
  { path: "/dashboard", component: <QwikMedicDashboard /> },
  { path: "/medicine-requests", component: <AllMedicineRequests /> },
  { path: "/help-support", component: <AllHelpSupport /> },

  // qwik bistro 
  { path: "/all-qwikbistro-orders", component: <AllQwikBistroOrders /> },
  { path: "/update-qwikbistro-order/:orderId", component: <UpdateQwikBistroOrder /> },
  { path: "/create-qwikbistro-order", component: <CreateQwikBistroOrderPage /> },
  { path: "/all-customers", component: <AllCustomers /> },
  { path: "/customer-details/:id", component: <CustomerDetailsPage /> },
  { path: "/create-customer", component: <CreateCustomerPage /> },
  { path: "/all-coupons", component: <AllCoupons /> },
  { path: "/create-coupon", component: <CreateCoupon /> },
  { path: "/all-menu-items", component: <AllMenuItems /> },
  { path: "/create-menu-item", component: <CreateMenuItem /> },
  { path: "/expenses", component: <AllExpenses /> },
  { path: "/create-expense", component: <CreateExpense /> },
  // { path: "/create-expenses", component: <CreateExpenses /> },
  { path: "/ingredients", component: <AllIngredients /> },
  { path: "/all-analytics", component: <Analytics /> },
  { path: "/recipes", component: <AllRecipes /> },
  { path: "/create-recipe", component: <CreateRecipePage /> },
  { path: "/create-recipe/:id", component: <CreateRecipePage /> },
  { path: "/create-qwik-bistro-payment", component: <CreatePaymentPage /> },






  { path: "/create-client", component: <CreateClient /> },

  { path: "/create-earning", component: <AddEarning /> },
  { path: "/all-earnings", component: <AllEarnings /> },

  { path: "/create-costing", component: <AddCosting /> },
  { path: "/all-costings", component: <AllCostings /> },

  { path: "/analytics", component: <AllAnalytics /> },

  { path: "/transactions", component: <Transactions /> },

  { path: "/worklog", component: <AllWorkLogs /> },
  { path: "/add-worklog", component: <AddWorkLog /> },
  { path: "/edit-worklog", component: <EditWorkLog /> },

  { path: "/leads-summary", component: <AllLeadsSummary /> },

  { path: "/all-fixed-costs", component: <AllFixedCosts /> },
  { path: "/admin-dashboard", component: <AdminDashboard /> },


  // In your App.js or routing file
  // {
  //   path: "/worklog",
  //   element: <AllWorkLogs />
  // },
  // {
  //   path: "/worklog/add",
  //   element: <AddWorkLog />
  // },
  // {
  //   path: "/worklog/edit/:id",
  //   element: <EditWorkLog />
  // }

];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  {
    path: "/auth-two-step-verification-2",
    component: <TwostepVerification2 />,
  },
];

export { userRoutes, authRoutes };
